var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNa = function SvgIconNa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M3.515 20.485c.503.503 1.04.952 1.603 1.348L21.833 5.118a12.1 12.1 0 0 0-2.952-2.951L2.167 18.881q.592.847 1.348 1.604"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M3.515 3.515C-.27 7.3-.997 12.986 1.333 17.502l16.17-16.169C12.987-.997 7.3-.271 3.515 3.515"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M20.485 20.485c3.786-3.786 4.513-9.472 2.182-13.988L6.498 22.667c4.516 2.33 10.202 1.603 13.987-2.182"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m9.914 6.782-1.345.632.716 1.303-1.46-.28-.185 1.475-1.017-1.085-1.017 1.085-.185-1.475-1.46.28.716-1.303-1.345-.632 1.345-.633-.716-1.302 1.46.28.185-1.476 1.017 1.085L7.64 3.651l.185 1.475 1.46-.279-.716 1.302z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconNa;